import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"

import { BACKEND_APIS } from "@constants"


export default function AppFrequenciesAutocomplete({ ...props }) {
    return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		multiple
		label="Frequencies"
		placeholder="All Frequencies"
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/report/options/frequency`}
		{...props}
	/>
}